/**
 * this file is in JavaScript since it is shared between the client and server
 * It's used to push Algolia search results to the correct category
 */

import TAG_CATEGORY_MAP from './constants/categories.json' assert { type: 'json' }

const TAG_CATEGORY_MAP_TYPED = TAG_CATEGORY_MAP

/**
 *
 * @param {string|undefined} tag
 * @returns {string} category
 */
export function getCategoryFromTag(tag) {
  const category = Object.keys(TAG_CATEGORY_MAP).find((cat) => {
    const tags = TAG_CATEGORY_MAP_TYPED[cat]
    return tags.indexOf(tag) > -1
  })

  return category
}
